"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCharter = function SvgCharter(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    stroke: "#C2C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 23c5.523 0 10-4.477 10-10S18.523 3 13 3 3 7.477 3 13s4.477 10 10 10Z",
    stroke: "#C2C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.114 13.423-2.77 1.698s-.734.572-2.12.286c-1.386-.286-2.808-.6-2.808-.6s-.305-.111-.515.161c-.21.272.136.435.136.435l2.138 1.548s.456.452 1.127.333c.672-.118 2.646-.52 2.646-.52s1.348-.287 2.95-1.287c1.604-1 7.333-4.476 7.333-4.476s2.23-1.268 2.006-1.798c-.223-.53-1.509-.39-2.123-.195-.615.195-5.413 2.913-5.413 2.913L9.443 10.12s-.68-.161-.34.236c.34.396 3.672 3.712 3.672 3.712m1.303 1.886 1.43 1.424s.414.329.497-.815c.084-1.144.168-2 .168-2",
    stroke: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCharter);
var _default = exports["default"] = Memo;